// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"X2-z"};